<template>
  <div
    v-if="formattedContent"
    ref="wrapperRef"
    :class="[
      'bp1440-w-740 bp1680-w-863 relative flex max-w-185 flex-col px-5 md:w-151.25 md:px-0 lg:w-153.75 xl:w-[65.85%] 2xl:w-215.75',
      {
        'mx-auto': !isEmbedded,
        'mb-10 md:mb-15 xl:mb-17.5 2xl:mb-20': !isEmbedded && hasNextWysiwyg,
        'mb-20 md:mb-25 xl:mb-30 2xl:mb-35': !isEmbedded && !hasNextWysiwyg,
      },
    ]"
  >
    <h2
      v-if="heading?.[locale]"
      class="mb-2.5 text-1.5xl/[115%] xl:mb-5 xl:text-[26px]/[115%] 2xl:text-3xl/[35px]"
    >
      {{ heading?.[locale] }}
    </h2>

    <div
      v-if="formattedContent"
      :style="[contentStyle, fadeMaskStyle]"
      class="relative overflow-hidden transition-all duration-500 ease-in-out"
    >
      <div
        ref="innerRef"
        :class="[
          'translate-color bp1440-text-20 block text-base leading-[130%] duration-300 md:text-[17px] xl:text-xl xl:leading-[120%] 2xl:text-[23px] [&_.wysiwyg-media]:my-4 [&_.wysiwyg-media]:block [&_.wysiwyg-youtube]:my-4 [&_a]:underline [&_a]:decoration-solid [&_a]:hover:text-gray-medium [&_b]:bg-gray-light [&_h1]:mb-6 [&_h1]:font-header [&_h1]:text-6xl/[100%] [&_h2]:mb-5 [&_h2]:font-header [&_h2]:text-4.5xl/[105%] [&_h3]:mb-4 [&_h3]:font-header [&_h3]:text-xl/[120%] [&_h3]:text-[23px] [&_h3]:text-gray-medium [&_h4]:mb-3 [&_h4]:font-header [&_h4]:text-xl/[120%] [&_h4]:text-[23px] [&_iframe]:aspect-video [&_iframe]:w-full [&_li]:leading-[130%] xl:[&_li]:leading-[120%] [&_li>p]:mb-0 [&_ol]:mb-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_strong]:bg-gray-light [&_strong]:font-normal [&_ul]:mb-5 [&_ul]:list-disc [&_ul]:pl-5 [&_ul>p]:mb-0',
          pCount > 1 ? '[&_p]:mb-5 [&_p]:last:mb-5' : '',
        ]"
      >
        <div v-html="formattedContent" />
      </div>
    </div>

    <ShowMoreButton
      v-if="content && showButton"
      v-model:is-expanded="isExpanded"
      button-class="pt-5 lg:pt-7.5"
      text-class="md:text-[17px] 2xl:text-xl"
      :button-color="buttonColor"
    />
  </div>
</template>

<script setup lang="ts">
import type { LocalizedString } from '~/types'

interface Props {
  heading?: LocalizedString
  content: any
  buttonColor?: 'light' | 'dark'
  isEmbedded?: boolean
  hasNextWysiwyg?: boolean
}

const props = defineProps<Props>()

const { locale } = useI18n()

const wrapperRef = ref<HTMLElement | null>(null)
const innerRef = ref<HTMLElement | null>(null)

const { formattedContent, pCount } = useWysiwygContent(props.content)

const { isExpanded, showButton, contentStyle } = useWysiwygExpand(
  formattedContent,
  wrapperRef,
  innerRef,
)

const fadeMaskStyle = computed(() => {
  if (isExpanded.value || !showButton.value) return {}

  const mask =
    'linear-gradient(to bottom, black calc(100% - 32px), transparent 100%)'
  return {
    maskImage: mask,
    WebkitMaskImage: mask,
  }
})
</script>
